import React, { useMemo } from 'react';
import { IconCalendar } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import { formatDisplayDate } from '@/utils/Formatters/formatDate';
import * as Styles from './DateInput.styles';

const DateInput = ({
  label,
  value,
  onChange,
  max,
  min,
}) => {
  const { marketing: marketingLocale } = useLocale();
  const { multiAgentScreens: multiAgentScreensLocale } = marketingLocale;
  const { header: headerLocale } = multiAgentScreensLocale;

  const formattedDate = useMemo(() => formatDisplayDate(value), [value]);

  const handleDateChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Styles.DateInputWrapper>
      <Styles.DateInputContainer>
        <Styles.CalendarIcon>
          <IconCalendar color="lowLight" />
        </Styles.CalendarIcon>
        <Styles.DateInputContent>
          <Styles.DateInputLabel>{label}</Styles.DateInputLabel>
          <Styles.DateInputValue>{formattedDate || headerLocale.selectDatePlaceholder}</Styles.DateInputValue>
        </Styles.DateInputContent>
        <Styles.DateInputField
          type="date"
          value={value}
          onChange={handleDateChange}
          max={max}
          min={min}
        />
      </Styles.DateInputContainer>
    </Styles.DateInputWrapper>
  );
};

export default DateInput;
